import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useViewport } from '@sbt-web/hooks';
import { Carousel } from '@sbt-web/carousel';
import type { Badge } from '@sbt-web/network/types';
import { SvgIcon } from '../SvgIcon';
import classes from './index.module.scss';
type Props = {
  badges: Badge[];
  activeIndex: number;
};
export const AchievementInfosCarousel = t0 => {
  const $ = _c(13);
  const {
    badges: t1,
    activeIndex: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const badges = t3;
  const activeIndex = t2 === undefined ? 0 : t2;
  const {
    isMobile
  } = useViewport();
  const renderBadgeInfo = _temp;
  if (badges.length === 1) {
    let t4;
    if ($[2] !== badges[0]) {
      t4 = renderBadgeInfo(badges[0]);
      $[2] = badges[0];
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] !== badges) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = badge_0 => <li key={badge_0.id}>{renderBadgeInfo(badge_0)}</li>;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = badges.map(t5);
    $[4] = badges;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !isMobile;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      left: "Precedente",
      right: "Prossima"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== activeIndex || $[9] !== isMobile || $[10] !== t4 || $[11] !== t5) {
    t7 = <Carousel listItems={t4} showButtons={t5} withDots={isMobile} currentIndex={activeIndex} labelArrows={t6} cssClass={classes.carousel} />;
    $[8] = activeIndex;
    $[9] = isMobile;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
function _temp(badge) {
  return <div className={classes.badgeInfoWrapper}><div className={classes.iconWrapper}><SvgIcon iconName={badge?.icon} isInfo={false} className={classes.icon} /></div><h2 className="body-text semibold">{badge.name}</h2><p className={classNames("body-text small", classes.description)}>{badge.description}</p><div className={classes.info}>{badge?.infoIcon && <SvgIcon iconName={badge.infoIcon} isInfo={true} className={classes.infoIcon} />}<span className={classNames(classes.infoText, "caption small book")}>{badge?.info}</span></div></div>;
}